import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Stack,
} from "@mui/material";
import Grid from '@mui/material/Grid';
import Chart from "react-apexcharts";
import axios from "axios";
import { motion } from "framer-motion";

const apiUrl = process.env.REACT_APP_API_RESERVAS;

const DashboardFederaciones = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(0);

  const [totalReservas, setTotalReservas] = useState(0);
  const [federacionesActivas, setFederacionesActivas] = useState(0);
  const [personasAlojadas, setPersonasAlojadas] = useState(0);
  
  
  

  const [barChartData, setBarChartData] = useState({ series: [], categories: [] });
  const [pieChartData, setPieChartData] = useState({ series: [], labels: [] });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(apiUrl);
        const data = res.data;

        const filtradas = data.filter((r) => {
          const fecha = new Date(r.fecha_entrada);
          return (
            fecha.getFullYear() === parseInt(year) &&
            (month === 0 || fecha.getMonth() + 1 === parseInt(month))
          );     
        }); 
        setTotalReservas(filtradas.length);
        const federacionesSet = new Set();
        const personasSet = new Set();
     

        setFederacionesActivas(federacionesSet.size);
        setPersonasAlojadas(personasSet.size);

        const federacionCounts = {};
        filtradas.forEach((r) => {
          r.miembros.forEach((m) => {
            if (!m.federacion_deporte) return;
            const key = m.federacion_deporte;
            federacionCounts[key] = (federacionCounts[key] || 0) + 1;
          });
        });

        const labels = Object.keys(federacionCounts);
        const values = Object.values(federacionCounts);

        setBarChartData({
          categories: labels,
          series: [{ name: "Reservas", data: values }],
        });

        setPieChartData({ labels, series: values });
      } catch (error) {
        console.error("Error al cargar reservas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [year, month]);

  if (loading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: "60vh" }}>
        <CircularProgress size={60} color="primary" />
        <Typography sx={{ mt: 2 }}>Cargando dashboard...</Typography>
      </Stack>
    );
  }

  return (
    <Box p={3}>
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <Typography variant="h4" gutterBottom>
          Dashboard de Reservas por Federación
        </Typography>
      </motion.div>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[{
          label: "Total de Reservas",
          value: totalReservas,
        }, {
          label: "Federaciones Activas",
          value: federacionesActivas,
        }, {
          label: "Personas Alojadas",
          value: personasAlojadas,
        }].map((card, index) => (
          <Grid item xs={6} sm={3} key={index}>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * index }}>
              <Card>
                <CardContent>
                  <Typography variant="subtitle1">{card.label}</Typography>
                  <Typography variant="h5">{card.value}</Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}

        <Grid item xs={6} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Año</InputLabel>
            <Select value={year} label="Año" onChange={(e) => setYear(e.target.value)}>
              {[2023, 2024, 2025].map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Mes</InputLabel>
            <Select value={month} label="Mes" onChange={(e) => setMonth(e.target.value)}>
              <MenuItem value={0}>Todo el año</MenuItem>
              {["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
                .map((m, i) => (
                  <MenuItem key={i + 1} value={i + 1}>{m}</MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={12} md={7}>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
            <Typography variant="h6" gutterBottom>Reservas por Federación</Typography>
            <Chart
              options={{
                chart: { id: "bar-chart" },
                xaxis: { categories: barChartData.categories },
                colors: ["#007bff"],
              }}
              series={barChartData.series}
              type="bar"
              height={350}
            />
          </motion.div>
        </Grid>

        <Grid item xs={12} md={5}>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }}>
            <Typography variant="h6" gutterBottom>Distribución (%)</Typography>
            <Chart
              options={{
                labels: pieChartData.labels,
                legend: { position: "bottom" },
              }}
              series={pieChartData.series}
              type="donut"
              height={320}
            />
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardFederaciones;


